import ReactGA from 'react-ga'
import { GOOGLE_ANALYTICS } from './environments'

ReactGA.initialize(GOOGLE_ANALYTICS.trackingId)
export default ReactGA
